import React from 'react';
import { Column } from 'types/Table';

interface ColumnProps {
    items: Column[];
    cardTitleIndex: number;
    onClick: () => void;
    buildTableProps: (i: number, onClick: () => void) => { titleHtml: React.ReactNode, cardBodyTitleClass: string };
}

export const ColumnComponent = ({
    items,
    cardTitleIndex,
    onClick,
    buildTableProps,
}: ColumnProps) => {
    const getBodyText = column => {
        if (typeof column == 'string') {
            return column;
        }

        return column.body || '';
    };

    return items.map((column, i) => {
        if (!column?.body) {
            return null;
        }

        if (typeof column === 'object' && column.cardHidden === true) {
            return <span key={`column-${i}-removed`} className="column-removed"/>;
        }

        if (column.originalIndex === cardTitleIndex) {
            return <span key={`column-${i}-removed`} className="column-removed"/>;
        }

        const { titleHtml, cardBodyTitleClass } = buildTableProps(column.originalIndex, onClick);

        return (
            <div
                key={`card-${i}-body`}
                className={cardBodyTitleClass}
                onClick={onClick}
            >
                {titleHtml}
                <span className={'body ' + column?.className}>
                    {getBodyText(column)}
                </span>
            </div>);
    });
};
